
import { Interval } from '@app/shared/enums/interval.enum';
import { DateUtils, RealEstateLevel } from '@smooved/core';

export const defaultLevel = RealEstateLevel.Group;
export const fromDate = DateUtils.tz().subtract(3, 'quarter').startOf('quarter').toDate();
export const defaultInterval = Interval.All;
